module.exports = __webpack_public_path__ + "img/bg-header@3x.bd976f7.jpg";